import * as yup from 'yup'
import get from 'lodash/get'

import { Environment } from '../../../constants/enums'

export interface ConfigData {
  apiUrl: string
  environment: string
  featureFlags?: {
    ONLINE?: boolean
  }
  isDevelopment: boolean
  isLocalhost: boolean
  sentry: string
}

const validationSchema = yup.object().shape({
  ADOBE: yup.string().url(),
  API_URL: yup.string().required(),
  APP_ID: yup.string().required(),
  ENVIRONMENT: yup.string().oneOf(Object.values(Environment)),
  FEATURE_FLAGS: yup.object().shape({ ONLINE: yup.boolean() }),
  SENTRY: yup.string().url(),
})

export const getConfiguration = (data: Object): ConfigData => {
  try {
    validationSchema.validateSync(data)
  } catch (ex) {
    const error: any = new Error(`File config.json is not valid! ${ex.message}`)
    throw error
  }

  const apiUrl = get(data, 'API_URL')
  const environment = get(data, 'ENVIRONMENT', Environment.PROD)
  const featureFlags = get(data, 'FEATURE_FLAGS', {})
  const isDevelopment = [Environment.DYNDEV, Environment.LOCALHOST, Environment.TST1].includes(
    environment
  )
  const isLocalhost = environment === 'LOCALHOST'
  const sentry = get(data, 'SENTRY')

  return {
    apiUrl,
    environment,
    featureFlags,
    isDevelopment,
    isLocalhost,
    sentry,
  }
}
